import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
export const STATUS_PALETTE = {
  Draft: {
    bg: palette.shades[300],
    color: palette.shades[700]
  },
  Active: {
    bg: palette.success.light,
    color: palette.success.dark
  },
  Paused: {
    bg: palette.warning.light,
    color: palette.warning.dark
  },
  Canceled: {
    bg: palette.error.light,
    color: palette.error.dark
  }
};
export const SUBSCRIPTION_STATUS_CANCELED = 'Canceled';
export const ASSIGNABLE_SUBSCRIPTION_STATUSES = Object.keys(STATUS_PALETTE).filter(status => status !== SUBSCRIPTION_STATUS_CANCELED);
export function getSubscriptionStatusTagSx(status) {
  const p = STATUS_PALETTE[status] || {
    bg: '#F5F5F5',
    color: '#616161'
  };
  return {
    backgroundColor: p.bg,
    color: p.color,
    fontWeight: 600,
    fontSize: '0.75rem',
    padding: '4px 10px',
    borderRadius: '4px'
  };
}
function getSubscriptionPrices(sub) {
  var _ref, _sub$prices;
  return (_ref = (_sub$prices = sub.prices) !== null && _sub$prices !== void 0 ? _sub$prices : sub.pricings) !== null && _ref !== void 0 ? _ref : [];
}
function priceKey(p) {
  var _ref2, _p$id;
  return (_ref2 = (_p$id = p.id) !== null && _p$id !== void 0 ? _p$id : p.code) !== null && _ref2 !== void 0 ? _ref2 : '';
}
function formatPrice(val) {
  return typeof val === 'number' && !Number.isNaN(val) ? "$".concat(Number(val).toFixed(2)) : '-';
}
function formatPriceItemAmount(p) {
  var _p$priceTableResponse;
  if (p.amount != null && typeof p.amount === 'string') return p.amount;
  const isTiered = (p.priceType || p.type || '').toLowerCase() === 'tiered';
  const tierTable = (_p$priceTableResponse = p.priceTableResponse) !== null && _p$priceTableResponse !== void 0 ? _p$priceTableResponse : p.tierTableResponse;
  if (isTiered && tierTable) {
    var _tierTable$tierPrice;
    const amounts = ((_tierTable$tierPrice = tierTable.tierPrice) !== null && _tierTable$tierPrice !== void 0 ? _tierTable$tierPrice : []).map(t => t.amount).filter(n => typeof n === 'number');
    const minPrice = typeof p.minimumPrice === 'number' && !Number.isNaN(p.minimumPrice) ? p.minimumPrice : typeof tierTable.minimumPrice === 'number' ? tierTable.minimumPrice : amounts.length ? Math.min(...amounts) : null;
    return minPrice != null ? "Min ".concat(formatPrice(minPrice)) : formatPrice(null);
  }
  return formatPrice(p.fixedPrice);
}

/** Pricings that appear in every given subscription (by id/code). */
export function getCommonPricings(subscriptions) {
  if (!subscriptions.length) return [];
  const keysPerSub = subscriptions.map(sub => {
    return new Set(getSubscriptionPrices(sub).map(p => priceKey(p)).filter(Boolean));
  });
  const firstKeys = keysPerSub[0];
  const commonKeys = [...firstKeys].filter(key => keysPerSub.every(set => set.has(key)));
  const byKey = new Map();
  getSubscriptionPrices(subscriptions[0]).forEach(p => {
    const k = priceKey(p);
    if (commonKeys.includes(k) && !byKey.has(k)) {
      var _ref3, _p$priceType, _ref4, _p$productName, _p$code, _p$name;
      const amount = formatPriceItemAmount(p);
      const type = (_ref3 = (_p$priceType = p.priceType) !== null && _p$priceType !== void 0 ? _p$priceType : p.type) !== null && _ref3 !== void 0 ? _ref3 : '';
      const productName = (_ref4 = (_p$productName = p.productName) !== null && _p$productName !== void 0 ? _p$productName : p.productId) !== null && _ref4 !== void 0 ? _ref4 : '';
      byKey.set(k, _objectSpread(_objectSpread({}, p), {}, {
        code: (_p$code = p.code) !== null && _p$code !== void 0 ? _p$code : p.id,
        name: (_p$name = p.name) !== null && _p$name !== void 0 ? _p$name : p.priceName,
        amount,
        type,
        productName
      }));
    }
  });
  return commonKeys.map(key => byKey.get(key)).filter(Boolean);
}

/** All unique pricings (by id/code) across subscriptions — for "Add pricings" catalog. */
export function getAllPricingsCatalog(subscriptions) {
  const byKey = new Map();
  subscriptions.forEach(sub => {
    getSubscriptionPrices(sub).forEach(p => {
      var _p$code2, _p$name2;
      const k = priceKey(p);
      if (k && !byKey.has(k)) byKey.set(k, _objectSpread(_objectSpread({}, p), {}, {
        code: (_p$code2 = p.code) !== null && _p$code2 !== void 0 ? _p$code2 : p.id,
        name: (_p$name2 = p.name) !== null && _p$name2 !== void 0 ? _p$name2 : p.priceName
      }));
    });
  });
  return [...byKey.values()];
}